import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

export interface IFinanceSummay {
  clinic_ids: Array<string>,
  start_date: string,
  end_date: string
}

AxiosCurlirize(axios, () => { });
type ICartAPIResponse = { status: boolean; message: any };

export const usePaymentFinanceSummayAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (paramsBody: IFinanceSummay) => {
      try {
        dispatch(
          setLoading({
            key: "isFinanceSummaryLoading",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .post(`${PAYMENT_MODULE?.FINANCE_SUMMARY_API?.baseURL}`, paramsBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              // toastNotification(res.data.message);
              dispatch(
                setLoading({
                  key: "isFinanceSummaryLoading",
                  status: false,
                }),
              );
              return { status: true, message: res.data?.data };
            } else {
              return { status: false, message: [] };
            }
          })
          .catch((e: AxiosError) => {
             dispatch(
                setLoading({
                  key: "isFinanceSummaryLoading",
                  status: false,
                }),
              );
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: [] };
          });
        return response;
      } catch (e: any) {
         dispatch(
                setLoading({
                  key: "isFinanceSummaryLoading",
                  status: false,
                }),
              );
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
